// This is based on the mothership's
//   /app/assets/javascripts/kinesis.js
// It has some slight functional differences, but is otherwise
// copied verbatim.

let kinesis;

export function kinesisConnection(enabledCallback, disabledCallback) {
  if (SCORE_INTAKE.isEnabled()) {
    // Create Kinesis object if not defined yet. Session expiration is handled
    // by the Kinesis object via it's retry mechanism
    if (typeof kinesis === 'undefined') {
      var options = {
        logLevel: SCORE_INTAKE.cfg.log_level,
        maxRetry: SCORE_INTAKE.cfg.max_retry,
        maxDelay: SCORE_INTAKE.cfg.max_delay,
        withCredentials: true
      };
      if (SCORE_INTAKE.cfg.endpoint_url) {
        options.endpointUrl = SCORE_INTAKE.cfg.endpoint_url;
      }
      // Kinesis var is defined in _resource.html.erb
      kinesis = new Kinesis(
        Routes.kinesisSessionURL( SCORE_INTAKE.cfg.named_stream ),
        options
      );

      kinesis.error(function () {
        disabledCallback();
      });
    }
    enabledCallback(kinesis);
  } else if (typeof disabledCallback === 'function') {
    disabledCallback();
  }
}

export const SCORE_INTAKE = {
  // Values that the primary flag can hold in the SCORE_INTAKE.cfg
  // 'direct' - submit scores to the rails app first, then kinesis
  // 'kinesis' - submit scores to kinesis only (with fallback to rails)
  // The record sent to kinesis should have a primary flag on it with the
  // same value as the primary flag in SCORE_INTAKE.cfg. This will be
  // used in the AWS Lambda that submit scores to the rails app to
  // determine whether to submit a message or not.
  DEST_DIRECT: 'direct',
  DEST_KINESIS: 'kinesis',

  cfg: {enabled: false},
  source: null,
  retryCount: 0,
  retryMax: 3,
  retryDelay: 1000,
  retryDelayMax: 10000,

  // The server can send down a `kinesis_proportion` to the page to
  // throttle clients using kinesis-primary. On config load, if this
  // is present, the app here will randomly decide whether to cut off
  // kinesis primary regardless of other factors.
  kinesisThrottlerOK: true,

  loadConfig: function (environment) {
    SCORE_INTAKE.source = environment;
    var xhr = new XMLHttpRequest();
    xhr.ontimeout = function () {
      SCORE_INTAKE.handleError('score-intake: timed out trying to get the configuration for ' + environment + '');
    };
    xhr.onload = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var allConfigs = JSON.parse(xhr.response);
          if (environment in allConfigs) {
            SCORE_INTAKE.success(allConfigs[environment]);
          } else {
            SCORE_INTAKE.handleError('score-intake: no ' + environment + ' configuration found');
          }
        } else {
          SCORE_INTAKE.handleError('score-intake: error retrieving the ' + environment + ' configuration: ' + xhr.statusText);
        }
      } else {
        SCORE_INTAKE.handleError('score-intake: readyState is not correct: ' + xhr.readyState);
      }
    };
    xhr.onerror = function(e) {
      SCORE_INTAKE.handleError('score-intake: error occurred while trying to load the ' + environment + ' config: ' + e);
    };
    xhr.open("GET", Routes.scoreIntakeConfigURL(), true);
    xhr.timeout = 60000; // 1 minute
    xhr.send(null);
  },

  success: function(allConfigs) {
    SCORE_INTAKE.cfg = allConfigs;

    if (typeof allConfigs.kinesis_proportion === 'number') {
      SCORE_INTAKE.kinesisThrottlerOK = Math.random() < allConfigs.kinesis_proportion;
    }

    // Load kinesis.js into page
    var newScriptTag = document.createElement('script');
    newScriptTag.setAttribute('src', SCORE_INTAKE.cfg.js_url);
    document.head.appendChild(newScriptTag);
  },

  handleError: function(errMsg) {
    if (SCORE_INTAKE.retryCount < SCORE_INTAKE.retryMax) {
      setTimeout(function() {
        SCORE_INTAKE.loadConfig(SCORE_INTAKE.source);
      }, SCORE_INTAKE.retryDelay);
      SCORE_INTAKE.retryCount++;
      SCORE_INTAKE.retryDelay = Math.min(SCORE_INTAKE.retryDelay * 2, SCORE_INTAKE.retryDelayMax);
    }
  },

  isEnabled: function() {
    if (typeof SCORE_INTAKE.cfg === 'undefined' || typeof SCORE_INTAKE.cfg.enabled === 'undefined') {
      return false;
    }
    return SCORE_INTAKE.cfg.enabled;
  },

  isKinesisPrimary: function() {
    return SCORE_INTAKE.isEnabled() &&
      SCORE_INTAKE.kinesisThrottlerOK &&
      SCORE_INTAKE.cfg.primary === SCORE_INTAKE.DEST_KINESIS;
  },

  retryExponentially: function (maxTries, maxTimeout, action, fallback) {
    // Generic utility function to retry an action with exponential
    // backoff. Action will be called at least once. It will be passed
    // one argument, a function which indicates failure. That failure
    // call will trigger a re-try some time in the future. After
    // maxTries tries, or a total of maxTimeout milliseconds, the
    // failure call will instead trigger the fallback function.

    var deadline = Date.now() + maxTimeout;

    var tick = function (triesLeft) {
      var failureWithTries = function () { onFailure(triesLeft); };
      action( failureWithTries );
    };

    var onFailure = function (triesLeft) {
      if (triesLeft > 0) {
        var triesDone = maxTries - triesLeft;
        var multiplier = Math.pow( 2, (triesDone - Math.random()) );
        var delay = 1000 * multiplier;
        var atTime = Date.now() + delay;

        if (atTime < deadline) {
          console.log("Retrying in", delay, "ms.");
          setTimeout( function () {
            tick( triesLeft - 1 );
          }, delay );

        } else {
          console.log("Retry would surpass timeout. Failing out.");
          fallback();
        }

      } else {
        console.log("Retries exhausted.");
        fallback();
      }
    };

    tick(maxTries);

  }

};
